export const LOGO_URL = 'https://customer-assets.emergentagent.com/job_class-planner-146/artifacts/wu6s7sl6_Logo%20con%20Scritta.png';

export const DAYS = ['Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato', 'Domenica'];
export const PLANNER_DAYS = ['Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì'];

export const TIME_SLOTS = [];
for (let hour = 13; hour < 20; hour++) {
  for (let minute = 0; minute < 60; minute += 15) {
    TIME_SLOTS.push(`${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`);
  }
}

export const ATTENDANCE_STATUS = [
  "Presente",
  "Assente",
  "Assente Ingiustificato",
  "Insegnante Assente",
  "Festivo",
  "Recuperata"
];

export const STATUS_COLORS = {
  "Presente": "bg-green-100 text-green-800 border-green-300",
  "Assente": "bg-red-100 text-red-800 border-red-300",
  "Assente Ingiustificato": "bg-orange-100 text-orange-800 border-orange-300",
  "Insegnante Assente": "bg-yellow-100 text-yellow-800 border-yellow-300",
  "Festivo": "bg-purple-100 text-purple-800 border-purple-300",
  "Recuperata": "bg-indigo-100 text-indigo-800 border-indigo-300"
};

// Solid variants used for active pill / mobile toggles
export const STATUS_SOLID_COLORS = {
  "Presente": "bg-emerald-600 text-white",
  "Assente": "bg-rose-600 text-white",
  "Assente Ingiustificato": "bg-orange-600 text-white",
  "Insegnante Assente": "bg-yellow-500 text-white",
  "Festivo": "bg-purple-600 text-white",
  "Recuperata": "bg-indigo-600 text-white"
};

export const LESSON_COLORS = [
  { bg: '#DBEAFE', text: '#1D4ED8', border: '#93C5FD' },
  { bg: '#FEE2E2', text: '#B91C1C', border: '#FCA5A5' },
  { bg: '#FEF9C3', text: '#A16207', border: '#FDE047' },
  { bg: '#DCFCE7', text: '#15803D', border: '#86EFAC' },
  { bg: '#F3E8FF', text: '#6B21A8', border: '#D8B4FE' },
  { bg: '#FED7AA', text: '#C2410C', border: '#FDBA74' },
  { bg: '#CFFAFE', text: '#0E7490', border: '#67E8F9' },
  { bg: '#FCE7F3', text: '#BE185D', border: '#F9A8D4' },
];

export const timeToSlotIndex = (time) => {
  const [hours, minutes] = time.split(':').map(Number);
  return (hours - 13) * 4 + Math.floor(minutes / 15);
};

export const slotIndexToTime = (index) => {
  const hours = Math.floor(index / 4) + 13;
  const minutes = (index % 4) * 15;
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
};

export const getSlotCount = (startTime, endTime) => {
  return timeToSlotIndex(endTime) - timeToSlotIndex(startTime);
};
